module.exports = __webpack_public_path__ + "img/download_android_qr.0718e500.png";